import React, { PropsWithChildren } from 'react';
import { ButtonBase, ListItem, ListItemButton, Typography } from '@mui/material';

interface ListItemProps {
  onClick: () => void;
}

export const CategoryListItem: React.FC<PropsWithChildren<ListItemProps>> = ({
  onClick,
  children,
}) => (
  <ListItem onClick={onClick} disablePadding>
    <ListItemButton>
      <Typography fontSize={20} sx={{ color: 'text.secondary', pl: 1 }}>
        {children}
      </Typography>
    </ListItemButton>
  </ListItem>
);

export const LinkStyledListItem: React.FC<PropsWithChildren<ListItemProps>> = ({
  onClick,
  children,
}) => (
  <ListItem disablePadding onClick={onClick}>
    <ButtonBase
      sx={{
        color: 'primary.main',
        '&:hover': { textDecoration: 'underline' },
        fontSize: '18px',
        px: 3,
        py: 1,
        textAlign: 'start',
      }}
    >
      {children}
    </ButtonBase>
  </ListItem>
);
